import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import FeatureAnnouncementModal from './FeatureAnnouncementModal';
import { featureAnnouncementsAPI } from '../services/api';

/**
 * Global component to handle feature announcements across all dashboards.
 * This component handles the fetching, displaying, and dismissing of feature modals.
 */
function FeatureAnnouncementGlobal() {
  const [activeFeature, setActiveFeature] = useState(null);
  const [isFeatureModalOpen, setIsFeatureModalOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      checkFeatureAnnouncements();
    }
  }, [user, location.pathname]);

  const checkFeatureAnnouncements = async () => {
    try {
      // Get or create session ID for tracking
      let sessionId = sessionStorage.getItem('feature_announcement_session');
      if (!sessionId) {
        sessionId = Math.random().toString(36).substring(2, 15);
        sessionStorage.setItem('feature_announcement_session', sessionId);
      }

      const response = await featureAnnouncementsAPI.getActive();
      if (response.data.success && response.data.announcement) {
        setActiveFeature(response.data.announcement);
        setIsFeatureModalOpen(true);
      } else {
        setActiveFeature(null);
        setIsFeatureModalOpen(false);
      }
    } catch (err) {
      console.error('Error checking feature announcements:', err);
    }
  };

  const handleDismissFeature = async (id, permanent) => {
    try {
      const sessionId = sessionStorage.getItem('feature_announcement_session');
      // Mark as read/dismissed permanently so it disappears forever as per user requirement.
      await featureAnnouncementsAPI.dismiss(id, true, sessionId);
      
      setIsFeatureModalOpen(false);
      setActiveFeature(null);
    } catch (err) {
      console.error('Error dismissing feature announcement:', err);
    }
  };

  return (
    <FeatureAnnouncementModal
      announcement={activeFeature}
      isOpen={isFeatureModalOpen}
      onClose={() => setIsFeatureModalOpen(false)}
      onDismiss={handleDismissFeature}
    />
  );
}

export default FeatureAnnouncementGlobal;

